import {
  ScanMessageBox,
  ScanMessageContent,
  ScanMessageTitle,
  ScanNowLink,
} from "./styled"

interface IScanMessageBannerProps {
  message: string
}

const ScanMessageBanner = ({ message }: IScanMessageBannerProps) => {
  return (
    <ScanMessageBox>
      <svg
        style={{ flexShrink: 0, width: 20, height: 20, marginTop: 3 }}
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.99984 0.833334C15.0624 0.833334 19.1665 4.93739 19.1665 10C19.1665 15.0626 15.0624 19.1667 9.99984 19.1667C4.93723 19.1667 0.83317 15.0626 0.83317 10C0.83317 4.93739 4.93723 0.833334 9.99984 0.833334ZM9.1665 6.66667C9.1665 6.20643 9.5396 5.83333 9.99984 5.83333C10.4601 5.83333 10.8332 6.20643 10.8332 6.66667V10C10.8332 10.4602 10.4601 10.8333 9.99984 10.8333C9.5396 10.8333 9.1665 10.4602 9.1665 10V6.66667ZM9.99984 12.5C10.4601 12.5 10.8332 12.8731 10.8332 13.3333C10.8332 13.7936 10.4601 14.1667 9.99984 14.1667H9.9915C9.53127 14.1667 9.15817 13.7936 9.15817 13.3333C9.15817 12.8731 9.53127 12.5 9.9915 12.5H9.99984Z"
          fill="#4BD9DE"
        />
      </svg>
      <ScanMessageContent>
        <ScanMessageTitle>{message}</ScanMessageTitle>
        <ScanNowLink href={import.meta.env.VITE_NATIVE_APP_SCAN_BODY_URL}>
          Scan Now
        </ScanNowLink>
      </ScanMessageContent>
    </ScanMessageBox>
  )
}

export default ScanMessageBanner
